import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { i18n } from 'next-i18next';

import { fetchPortfolio, fetchProject } from 'src/features/projects/projectsAPI';
import { setPortfolio, setProject } from 'src/features/projects/projectSlice';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const DefaultPage = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const project = useAppSelector((state) => state.project.project);
  const portfolio = useAppSelector((state) => state.project.portfolio);

  useEffect(() => {
    const { id,type } = router.query

    if(type === 'portfolio' && id){
      fetchPortfolio(id).then((portfolio) => {
        dispatch(setPortfolio(portfolio));
      });
    }
    else if(id){
      fetchProject(id).then((project) => {
        dispatch(setProject(project));
      });
    }
  }, [router.query]);

  useEffect(() => {
    const { id, type } = router.query
    let url = `/projects/${i18n.language}/`
    if (type === 'portfolio' && portfolio && portfolio.id == id){
      url += `${portfolio.slug}?id=${id}&type=portfolio`
      if (router.query.referral_code) {
        url += `&referral_code=${router.query.referral_code}`;
      }
      window.location.href = url ;
    }
    else if (project && project.id == id){
      url += `${project.slug}?id=${id}`
      if (router.query.referral_code) {
        url += `&referral_code=${router.query.referral_code}`;
      }
      window.location.href = url ;
    }

  }, [router.query, project, portfolio]);

  return <></>;
};

export async function getStaticProps({ locale }) {
    if (process.env.NODE_ENV === 'development') {
      await i18n?.reloadResources()
    }
    return {
      props: {
        ...(await serverSideTranslations(locale, ['common'])),
        'protected': true,
        isAdminOrDeveloper: true
      },
    }
  }

  export default DefaultPage
